import firebase from 'firebase/app'
import 'firebase/auth'

// 配置信息从 Firebase 控制台获取
const firebaseConfig = {
    apiKey: "AIzaSyAwxjt9UOzVJgWygCI9nTUPxwNILMR0W-8",
    authDomain: "draft2real-4a346.firebaseapp.com",
    projectId: "draft2real-4a346",
    storageBucket: "draft2real-4a346.firebasestorage.app",
    messagingSenderId: "798493490014",
    appId: "1:798493490014:web:4b5569ba0afb2542026dcf",
    measurementId: "G-HTMQ5SL0Q8"
  };

// 初始化 Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

// 导出 auth 实例和 firebase
export const auth = firebase.auth()
export default firebase
